
export const handleExpiredToken = () => {
    const currentUser = localStorage.getItem("currentUser")
    if (!currentUser) return
    localStorage.removeItem('currentUser')
    window.dispatchEvent(new Event("storage"))
}

export const handleUserLogout = () => {
    const currentUser = localStorage.getItem("currentUser")
    if (!currentUser) return
    localStorage.removeItem('currentUser')
    window.dispatchEvent(new Event("storage"))
}